import { LAST_ACTIVE_ORGANIZATION_CACHE } from './cacheKeys';

const getLastActiveOrganizationStorageKey = (userId: string): string => `${LAST_ACTIVE_ORGANIZATION_CACHE}.${userId}`;

export const readLastActiveOrganizationId = (userId: string): string | null => {
  try {
    return window.localStorage.getItem(getLastActiveOrganizationStorageKey(userId));
  } catch {
    return null;
  }
};

export const storeLastActiveOrganizationId = (userId: string, organizationId: string) => {
  try {
    window.localStorage.setItem(getLastActiveOrganizationStorageKey(userId), organizationId);
  } catch {
    // Storage unavailable — restore will fall back to the deterministic sort
  }
};
